export const OutputBlockDocumentationMarkdown = `
## Output Block

**This should only be used within a subflow**

The Output block is used to specify which data within a subflow should be returned to the parent flow that calls the subflow. Choose a specific block's data to return.

### Input
- **Data**: The block to output from the subflow

### Output
- The output data from the specified block

### Notes
If you would like to return data from more than one block, use a Script Block to construct the data:

~~~javascript
return {
  parentBlock1: parentBlock1.data,
  labValues: FhirLabValuesBlock.data,
};
~~~
`;
